import React, { useEffect } from 'react';
import LoginSreen from '../components/Login'

const Login = () => {
  return (
    <React.Fragment>
        <div className="login">
            <div className="blacky">
                <LoginSreen/>
            </div>
        </div>
    </React.Fragment>
  )
}

export default Login